import { BACKEND_PUBLIC } from '@/api/base'

export async function feedbackSend(payload: any) {
  return BACKEND_PUBLIC.post('/feedback/send', { payload })
}
